import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation SuggestAnswerForQuestion(
    $customerId: ID!
    $question: String!
    $generationTool: GenerationToolEnum!
    $allInstructionsData: JSON!
    $urlExtractions: [UrlExtractionInput!]
  ) {
    suggestAnswerForQuestion(
      customerId: $customerId
      question: $question
      generationTool: $generationTool
      allInstructionsData: $allInstructionsData
      urlExtractions: $urlExtractions
    ) {
      answer
    }
  }
`;

export const suggestAnswerForQuestion = ({
  customerId,
  question,
  generationTool,
  allInstructionsData,
  urlExtractions,
}) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId, question, generationTool, allInstructionsData, urlExtractions },
  }).then(({ data }) => getSingleProp(data));
};
